<template>
<div class="pxy-0 c-dark-blue d-inline-block fs-16 fw-600 ta-left">
<star-rating :active-color="$assets.theme.primary" :inactive-color="$assets.subtheme.pale_primary" :increment="0.25" :max-rating="max_rating" :show-rating="false" :star-size="18" class="d-inline-block" read-only="" v-model="local_score">
</star-rating><span class="c-black fs-14 fw-400 ml-1" style="vertical-align: top" v-if="count > 0">{{ local_score }}</span>
<span class="c-black fs-14 fw-400 ml-1" style="vertical-align: top" v-if="count > 0">({{ count }})</span>
<img :class="border ? 'bc-light-gray b-1' : ''" :key="icon" :src="icon" class="d-inline-block ml-1 va-baseline" height="16" v-for="icon in icons" />

</div></template><script>
import StarRating from 'vue-star-rating'



export default {

  components: {

    'star-rating': StarRating

  },



  computed: {

    local_score: function() {

      return parseFloat(this.score)

    },



    max_rating: function() {

      if(this.max) {

        return parseInt(this.max)

      }

      return 5

    }

  },



  name: 'b-rating',

  props: ['name', 'score', 'count', 'max', 'icons', 'border']

}</script>
